<template>
  <div id="HampaPay" class="hampa-pay-page" dir="rtl">
    <div class="hampa-pay-shell">
      <loading v-if="loadingRender"></loading>
      <panel
        Title="پرداخت همراه بانک"
        :Des="pageDescription"
        :IsBtnBack="true"
        ClassCustom="bg-dark-Custom text-right mt-2"
      ></panel>

      <net-pa-card v-if="FastpaymentData.length != 0 && IsFastPayment" class="hampa-pay-card">
        <template slot="header">
          <h6 class="text-right mb-0">
            <i class="fas fa-credit-card ml-2"></i>
            پرداخت سریع
          </h6>
        </template>
        <template slot="content">
          <div class="hampa-pay-layout">
            <div class="hampa-fast-summary">
              <div class="hampa-fast-summary__title">کل مبلغ سررسید شده</div>
              <div class="hampa-fast-summary__meta">
                <span>{{ TotalFastPay.VamCoutFastPay }} وام</span>
                <span class="hampa-pay-result__due">جریمه {{ $Comma3ragham(TotalFastPay.SumJarmieFastPay) }}</span>
              </div>
              <div class="hampa-fast-summary__amount">{{ $Comma3ragham(TotalFastPay.SumMabFastPay + '') }}</div>
              <div class="hampa-fast-summary__words">{{ $Mab2persianToman(TotalFastPay.SumMabFastPay + '') }}</div>
            </div>

            <div class="hampa-fast-list">
              <div v-for="(item, index) in FastpaymentData" :key="index" class="hampa-fast-item">
                <div class="hampa-fast-item__row">
                  <span>{{ costCode != 945 ? 'نام تسهیلات' : 'نام قرارداد' }}</span>
                  <strong>{{ item.desNoe }}</strong>
                </div>
                <div class="hampa-fast-item__row">
                  <span>{{ costCode != 945 ? 'شماره تسهیلات' : 'شماره قرارداد' }}</span>
                  <strong dir="ltr">{{ item.vCode }}</strong>
                </div>
                <div class="hampa-fast-item__row">
                  <span>تاریخ قسط</span>
                  <strong dir="ltr">{{ item.tarix }}</strong>
                </div>
                <div class="hampa-fast-item__row">
                  <span>مبلغ قابل پرداخت</span>
                  <strong>{{ $Comma3ragham(item.mablghPardakht + '') }}</strong>
                </div>
                <div class="hampa-fast-item__row">
                  <span>مبلغ جریمه</span>
                  <strong class="hampa-pay-result__due">{{ item.wwwjarime == null ? 0 : $Comma3ragham(item.wwwjarime + '') }}</strong>
                </div>
                <div class="hampa-fast-item__switch">
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input InputText"
                      :checked="FastpaymentData[index].Active"
                      v-model="FastpaymentData[index].Active"
                      :id="FastpaymentData[index].vCode + 'active'"
                    />
                    <label class="custom-control-label Pointer" :for="FastpaymentData[index].vCode + 'active'">انتخاب</label>
                  </div>
                </div>
              </div>
            </div>

            <aside class="hampa-pay-checkout">
              <button
                type="button"
                class="btn hampa-pay-submit"
                :class="TotalFastPay.SumMabFastPay == 0 ? 'btn-secondary' : 'btn-success'"
                :disabled="TotalFastPay.SumMabFastPay == 0"
                @click="FastPay"
              >
                <span>پرداخت سریع</span>
                <span class="hampa-pay-submit__amount" dir="ltr">{{
                  $Comma3ragham(TotalFastPay.SumMabFastPay + "")
                }}</span>
              </button>
            </aside>
          </div>
        </template>
      </net-pa-card>

      <net-pa-card v-else-if="!IsFastPayment" class="hampa-pay-card">
        <template slot="header">
          <h6 class="text-right mb-0">
            <i class="fas fa-money-check-alt ml-2"></i>
            {{ !IsTashilat ? 'واریز به حساب' : costCode != 945 ? 'پرداخت تسهیلات' : 'پرداخت قرارداد' }}
          </h6>
        </template>
        <template slot="content">
          <div class="hampa-pay-layout">
            <div class="hampa-pay-main">
              <div class="hampa-pay-result">
                <span>{{ !IsTashilat ? 'شماره حساب' : costCode != 945 ? 'شماره تسهیلات' : 'شماره قرارداد' }} {{ vCode }}</span>
                <span>شناسه واریز {{ shenaseVariz }}</span>
                <span>{{ nameFamily }}</span>
                <span v-if="IsTashilat == true || costCode == 8" class="hampa-pay-result__due">
                  سررسید {{ tarihkSarsid }}
                </span>
                <span v-if="IsTashilat" class="hampa-pay-result__due">جریمه {{ wwwJarime }} ریال</span>
              </div>

              <input
                id="MabGhest"
                ref="MabGhest"
                dir="ltr"
                class="form-control hampa-pay-input hampa-pay-amount text-center"
                type="number"
                placeholder="مبلغ واریزی (ریال)"
                v-model="Mablagh"
                :disabled="(FixVariz && IsTashilat) || (FixVariz && costCode == 8)"
              />
              <div class="hampa-pay-amount-meta">
                <span class="hampa-pay-amount-formatted">{{ $Comma3ragham(Mablagh) }} ریال</span>
              </div>

              <div class="hampa-pay-result">
                <span>{{ txtNameFamilyVarizi != '' ? txtNameFamilyVarizi : nameFamily }}</span>
                <span dir="ltr">{{ codeMeli }}</span>
                <span dir="ltr">{{ mobile }}</span>
              </div>
              <textarea
                id="Des"
                class="form-control hampa-pay-input hampa-pay-notes text-right"
                placeholder="توضیحات واریزی"
                maxlength="300"
                rows="2"
                v-model="Des"
              ></textarea>
            </div>

            <aside class="hampa-pay-checkout">
              <payment
                v-if="wwwtblShobeId != 0"
                @GatewayCode="Get_GatewayCode"
                @FixVarizGhestHasJarime="FixVarizGhestHasJarime"
                @FixVarizGhest="FixVarizGhest"
                :wwwtblShobeid="wwwtblShobeId"
              >
                <template v-slot:ContentButtonPayment>
                  <button
                    type="button"
                    class="btn hampa-pay-submit"
                    :class="Mablagh.replace(/,/g, '') < 10000 ? 'btn-secondary' : 'btn-success'"
                    :disabled="Mablagh.replace(/,/g, '') < 10000 ? true : false"
                    @click="Payment"
                  >
                    واریز {{ GetMablagh }}
                  </button>
                </template>
              </payment>
              <p v-else class="hampa-pay-hint">درگاه پرداخت پس از بارگذاری اطلاعات حساب نمایش داده می‌شود.</p>
            </aside>
          </div>
        </template>
      </net-pa-card>
    </div>
  </div>
</template>
<script>
import Payment from './Payment.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import loading from '../Tools/NetPa/Loading.vue'
import Num2persian from 'num2persian'
export default {
  data() {
    return {
      MabFormulaJarime: 0,
      CheckUpMablagh: null,
      DataAxios_TokenResult: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TokenResult/NetPaToken',
      },
      DataAxios_TaahodatHampa: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatHampa',
      },
      DataAxios_SelAza: {
        ArryfildValue: '',
        Method: 'post',
        Action: 'SelAza/Hampa',
      },
      DataAxios_TaahodatById: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByIdNetpa',
      },
      DataAxios_ListTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/NetPa',
      },
      DataAxios_CheckUpMande: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'CheckUpMande',
      },
      DataAxiosFastPaymnet: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Fastpayment',
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: '',
      },
      IsTashilat: false,
      Mablagh: '',
      Email: '',
      Des: '',
      GatewayCode: null,
      FixVariz: false,
      IsToken: null,
      tarihkSarsid: null,
      vCode: '',
      shenaseVariz: '',
      shenase: null,
      nameFamily: '',
      txtNameFamilyVarizi: '',
      mobile: '',
      id: null,
      codeMeli: '',
      AzaID: null,
      resTaahodatId: null,
      wwwJarime: 0,
      costCode: null,
      wwwtblShobeId: 0,
      FastpaymentData: [],
      SumMabFastPay: 0,
      SumJarmieFastPay: 0,
      VamCoutFastPay: 0,
      TablooLength: 0,
      IsFastPayment: true,
      SumMablagh: 0,
      bnpCashDBtblAzaId: 0,
      bnpCashDBtblTaahodatId: 0,
      bnpCashDbtblAzaId: 0,
      Dargah: null,
      loadingRender: false,
      DataAxios_VarizGorohi: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      tblcustomer: {},
    }
  },
  components: {
    Payment,
    Panel,
    NetPaCard,
    loading,
  },
  created() {
    var axios = require('axios')
    var config = {
      method: 'GET',
      url: '/appSettings.json?nocache=123',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    }
    axios(config).then((result) => {
      this.gettblCustomer()
    })

  },
  mounted() {
    document.documentElement.classList.add('hampa-pay-html')
    document.body.classList.add('hampa-pay-html')
    this.$GetAppsettingsAsync().then(() => {
      this.gettblCustomer()
      if (this.$route.query.SarfaslTypeId == '1') {
        this.IsTashilat = true
      } else {
        this.IsTashilat = false
      }
      this.GetDataHampa()
        .then((data) => {
          if (!data) {
            this.loadingRender = true
          }
        })
        .finally(() => {        
          if (!this.IsFastPayment) {
            document.getElementById('MabGhest').focus()
          } else {
            this.$GatewayOld().then((data) => {
              if (data.status == 'Ok') {
                data.data.forEach((element) => {
                  if ((element.gatewayCode != null || element.gatewayCode != '') && element.isDefault == true) {
                    this.Dargah = element.id
                  }
                })
              } else {
                this.$mySweetDefaultTost('عدم وجود اطلاعات', data.msg, 'warning', 2000)
              }
            })
          }
        })
        .catch((error) => {
          console.error(error)
        })
    })
  },
  beforeDestroy() {
    document.documentElement.classList.remove('hampa-pay-html')
    document.body.classList.remove('hampa-pay-html')
  },
  updated() {
    this.$PutCommatoInput()
    // if (!this.IsFastPayment) {
    //   var mab = document.getElementById('MabGhest')
    //   if (mab.value.trim() == '') {
    //     document.getElementById('MabGhest').focus()
    //     document.getElementById('Des').value = ''
    //     this.$mySweetDefaultTost('مبلغ واریزی خالی می باشد', 'لطفا در ابتدا مبلغ واریزی را وارد نمایید', 'info', 2000)
    //   }
    // }
  },
  computed: {
    pageDescription() {
      const name = this.$session.get('NameSandogh') || (this.tblcustomer && this.tblcustomer.name)
      if (this.IsFastPayment && this.FastpaymentData.length != 0) {
        return name ? `پرداخت سریع اقساط — ${name}` : 'پرداخت سریع اقساط سررسید شده'
      }
      return name ? `واریز و پرداخت همراه بانک — ${name}` : 'واریز و پرداخت از طریق همراه بانک'
    },
    Mab2persian() {
      var Mab = this.Mablagh.replace(/,/g, '')
      Mab = Mab / 10
      return Num2persian(Mab) + ' تومان '
    },
    GetMablagh() {
      var Mab = this.Mablagh.replace(/,/g, '')
      Mab = Mab / 10
      return this.$Comma3ragham(Mab) + ' تومان '
    },
    TotalFastPay() {
      var shomarande = 0
      var SumMabFastPay = 0
      var VamCoutFastPay = 0
      var SumJarmieFastPay = 0
      var listFastpay = []
      for (let index = 0; index < this.FastpaymentData.length; index++) {
        const element = this.FastpaymentData[index]
        if (element.Active) {
          shomarande++
          SumMabFastPay += element.mablghPardakht
          SumJarmieFastPay += element.wwwjarime == null ? 0 : element.wwwjarime
          listFastpay.push(element)
        }
      }
      VamCoutFastPay = shomarande
      return {
        VamCoutFastPay: VamCoutFastPay,
        SumJarmieFastPay: SumJarmieFastPay,
        SumMabFastPay: SumMabFastPay,
        listFastpay: listFastpay,
      }
    },
  },
  methods: {
    Get_GatewayCode(val) {
      this.GatewayCode = val
    },
    FixVarizGhest(val) {
      this.FixVariz = val
    },
    FixVarizGhestHasJarime(val) {
      var jarime=this.wwwJarime
      if (jarime>0 ) {
        this.FixVariz = val
      }
    },
    Payment() {
      if (!this.$OnceGuard("Payment", 5000)) return; // NetPa HANDOFF S14 : double-submit (do darxast-e dargah)
      if (this.GatewayCode == 0) {
        if (this.costCode == 801) {
          this.$swal(
            'اختلال در پرداخت با درگاه',
            "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)" ,
            'warning'
          )
        } else {
          this.$mySweetDefaultTost('عدم انتخاب درگاه', 'درگاهی برای سامانه تنظیم نشده است', 'warning', 3000)
        }
      } else {       
        
        if (Number(this.Mablagh) < Number(this.CheckUpMablagh)) {
          
          var MablaghJarime = this.wwwJarime== null ? 0 : this.wwwJarime
          if (this.costCode == 561){
            this.MabFormulaJarime = (Number(this.Mablagh) / (Number(this.CheckUpMablagh))) * MablaghJarime
          }
          else{
            this.MabFormulaJarime = (Number(this.Mablagh) / (Number(this.CheckUpMablagh) - MablaghJarime)) * MablaghJarime

          }
        }else{
          this.MabFormulaJarime =this.wwwJarime== null ? 0 : this.wwwJarime
        }
        const WwwtblVarizGorohiRiz = []
        WwwtblVarizGorohiRiz.push({
          WwwtblTaahodatId: Number(this.$route.query.TaahodatId),
          Mablagh: Number(this.Mablagh.replaceAll(/,/g, '')),
          SharhRiz: this.vCode + 'پرداخت/ واریز  تکی همراه بانک ',
          WwwtblAzaId: Number(JSON.stringify(this.AzaID)),
          BnpCashDBtblTaahodatId: Number(this.bnpCashDBtblTaahodatId),
          BnpCashDBtblAzaId: this.bnpCashDbtblAzaId,
          MablaghJarime: Math.floor(this.MabFormulaJarime),
          TarixGhest: this.tarihkSarsid,
        })
        ;(this.DataAxios_VarizGorohi.ArryfildValue.Mablagh = Number(this.Mablagh.replaceAll(/,/g, ''))), (this.DataAxios_VarizGorohi.ArryfildValue.CodeRahgiri = 0)
        this.DataAxios_VarizGorohi.ArryfildValue.Tarix = this.$store.state.JalaliDate
        this.DataAxios_VarizGorohi.ArryfildValue.Sharh = 'پرداخت/ واریز  همراه بانک'
        this.DataAxios_VarizGorohi.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
        this.DataAxios_VarizGorohi.ArryfildValue.CustCode = Number(this.tblcustomer.custCode)
        this.DataAxios_VarizGorohi.ArryfildValue.tblComboIdVaziatGrp312 = 5538
        ;(this.DataAxios_VarizGorohi.ArryfildValue.wwwtblAzaId = this.AzaID), (this.DataAxios_VarizGorohi.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz)
        this.$PostData(this.DataAxios_VarizGorohi).then((result) => {
          if (result.status === 'Success') {
            this.$Payment(
              this.GatewayCode + '',
              this.Mablagh.replaceAll(/,/g, ''),
              this.txtNameFamilyVarizi != '' ? this.txtNameFamilyVarizi : this.nameFamily,
              this.Email,
              this.mobile,
              Number(this.$route.query.TaahodatId),
              this.shenaseVariz == '' ? '' : this.shenaseVariz,
              this.vCode,
              this.Des,
              this.$route.query.tblAzaIdVariz > 0 ? this.$route.query.tblAzaIdVariz + '' : this.AzaID + '',
              this.tblcustomer.custCode,
              JSON.stringify(this.wwwtblShobeId),
              result.idRepoMaster,
              this.codeMeli,
              this.nameFamily,
              this.mobile,
              this.resTaahodatId[0].codeMeli
            )
          } else {
            this.$mySweetDefaultTost(' ', ' در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید', 'warning', 2000)
            this.DeleteAllItemsCart()
          }
        })

        this.loadingRender = true
        // this.$Payment(this.GatewayCode+"",
        // this.Mablagh,
        // this.nameFamily,
        // this.Email,
        // this.mobile,
        // Number(this.$route.query.TaahodatId),
        // this.shenaseVariz,
        // this.vCode,
        // this.Des,
        // JSON.stringify(this.AzaID),
        // this.costCode,
        // JSON.stringify(this.wwwtblShobeId),
        // 0,
        // this.codeMeli);
        this.loadingRender = false
      }
    },
    GetDataHampa() {
      return new Promise((resolve) => {
        this.loadingRender = true
        resolve(false)
        const formData = new FormData()
        formData.append('Token', this.$route.query.Token)
        this.DataAxios_TokenResult.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_TokenResult)
          .then((data) => {   
            
                     
            this.costCode = data.custCode.substring(1, 4)
            
            if (data.result == 'Failed') {
              this.$mySweetDefaultTost('عدم وجود اطلاعات', 'توکن ارسالی معتبر نمیباشد.', 'warning', 2000)
            } else {
              this.Token = data.result
            }
          })
          // NetPa HANDOFF bilit-e pardakht F1 : bilit baraye ozv-e token va hesab-e entekhab-shode (khata = mesl-e ghabl edame)
          .then(() => (this.Token ? this.$IssuePayTicket({ Token: this.$route.query.Token, TaahodatId: this.$route.query.TaahodatId }) : null))
          .finally(() => {
            if (this.Token) {
              if (this.$route.query.IsUSSD == undefined) {
                this.$session.set('TokenHampa', true)
              }
              const formData = new FormData()
              formData.append('TaahodatId', this.$route.query.TaahodatId)
              formData.append('wwwtblSarfaslTypeId', this.$route.query.SarfaslTypeId)
              this.DataAxios_TaahodatHampa.ArryfildValue = formData
              this.$PostFormData(this.DataAxios_TaahodatHampa)
                .then((data) => {
                  this.nameFamily = data.nameFamily
                  this.vCode = data.vCode

                  this.codeMeli = data.codeMeli
                  this.id = data.id
                  this.mobile = data.mobile
                  this.txtNameFamilyVarizi = ''
                  this.shenase = data.shenase
                  this.shenaseVariz = data.shenaseVariz
                })
                .finally(() => {
                  if (this.$route.query.wwwtblAzaId > 0) {
                    this.GetFastpaymentData()
                    this.loadingRender = false
                    resolve(true)
                    return
                  }

                  if (this.$route.query.tblAzaIdVariz > 0) {
                    const formData = new FormData()
                    formData.append('wwwtblAzaId', this.$route.query.tblAzaIdVariz)
                    this.DataAxios_SelAza.ArryfildValue = formData
                    this.$PostFormData(this.DataAxios_SelAza).then((data) => {
                      this.codeMeli = data.codeMeli
                      this.id = data.id
                      this.mobile = data.mobile
                      this.txtNameFamilyVarizi = data.ozvName + ' ' + data.ozvFamily
                      // this.resTaahodatId = data.filter(
                      //   (x) => x.id == this.$route.query.TaahodatId
                      // );
                      // this.bnpCashDBtblAzaId =
                      //   this.resTaahodatId[0].bnpCashDBtblAzaId;
                      // this.BnpCashDBtblTaahodatId =
                      //   this.resTaahodatId[0].BnpCashDBtblTaahodatId;
                      // this.wwwtblShobeId =
                      //   this.resTaahodatId[0].wwwtblShobeId;
                    })
                    // .finally(() => {
                    //   this.GetFastpaymentData();
                    //   this.loadingRender = false;
                    //   resolve(true);
                    // });
                  }

                  if (this.$route.query.SarfaslTypeId == '1') {
                    //vam

                    this.IsFastPayment = false
                    const formData = new FormData()
                    formData.append('Id', this.$route.query.TaahodatId)
                    this.DataAxios_TaahodatById.ArryfildValue = formData
                    this.$PostFormData(this.DataAxios_TaahodatById)
                      .then((data) => {
                        this.bnpCashDBtblTaahodatId = data[0].bnpCashDbtblTaahodatId
                        this.bnpCashDbtblAzaId = data[0].bnpCashDbtblAzaId
                        this.AzaID = data[0].wwwtblAzaId
                        this.wwwtblShobeId = data.wwwtblShobeId
                      })
                      .finally(() => {
                        // this.AzaID=this.$route.query.tblAzaIdVariz
                        const formData = new FormData()
                        formData.append('wwwtblAzaId', this.AzaID)
                        formData.append('wwwtblSarfaslTypeId', 1)
                        this.DataAxios_ListTaahodat.ArryfildValue = formData
                        this.$PostFormData(this.DataAxios_ListTaahodat)
                          .then((data) => {
                            this.resTaahodatId = data.filter((x) => x.id == this.$route.query.TaahodatId)
                            this.wwwtblShobeId = this.resTaahodatId[0].wwwtblShobeId
                            this.tarihkSarsid = this.resTaahodatId[0].minTarGhestBedehkar == '' ? this.resTaahodatId[0].tarixShoroAghsat : this.resTaahodatId[0].minTarGhestBedehkar
                          })
                          .finally(() => {
                            const formData = new FormData()
                            formData.append('wwwtblTaahodatId', this.resTaahodatId[0].id)
                            this.DataAxios_CheckUpMande.ArryfildValue = formData
                            this.$PostFormData(this.DataAxios_CheckUpMande).then((data) => {
                              if (data.length != 0) {
                                // console.log('/*/*/*/')
                              }
                            })
                            this.wwwJarime = this.resTaahodatId[0].wwwJarime != null ? this.resTaahodatId[0].wwwJarime : 0
                            if (this.costCode == 8) {
                              this.Mablagh = this.resTaahodatId[0].mabAvalinForPar + ''
                            } else {
                              if (this.resTaahodatId[0].mablaghGhestVam > 0) {
                                    this.Mablagh = this.resTaahodatId[0].sumGhabelPar
                                    
                                    this.CheckUpMablagh = this.resTaahodatId[0].sumGhabelPar
                                  } else {
                                    this.Mablagh = ''
                                  }
                              this.Mablagh = this.resTaahodatId[0].sumGhabelPar + ''
                            }
                            
                            //this.CheckUpMablagh = this.resTaahodatId[0].sumGhabelPar
                          })
                      })
                    this.loadingRender = false
                    resolve(true)
                  } else {
                    this.IsFastPayment = false
                    const formData = new FormData()
                    formData.append('Id', this.$route.query.TaahodatId)
                    this.DataAxios_TaahodatById.ArryfildValue = formData
                    this.$PostFormData(this.DataAxios_TaahodatById)
                      .then((data) => {
                        this.bnpCashDBtblTaahodatId = data[0].bnpCashDbtblTaahodatId
                        this.bnpCashDbtblAzaId = data[0].bnpCashDbtblAzaId
                        this.AzaID = data[0].wwwtblAzaId
                        this.wwwtblShobeId = data.wwwtblShobeId
                      })
                      .finally(() => {
                        // this.AzaID=this.$route.query.tblAzaIdVariz
                        const formData = new FormData()
                        formData.append('wwwtblAzaId', this.AzaID)
                        formData.append('wwwtblSarfaslTypeId', 2)
                        this.DataAxios_ListTaahodat.ArryfildValue = formData
                        this.$PostFormData(this.DataAxios_ListTaahodat)
                          .then((data) => {
                            this.resTaahodatId = data.filter((x) => x.id == this.$route.query.TaahodatId)
                            this.wwwtblShobeId = this.resTaahodatId[0].wwwtblShobeId
                            this.tarihkSarsid = this.resTaahodatId[0].minTarGhestBedehkar == '          ' ? this.resTaahodatId[0].tarixShoroAghsat : this.resTaahodatId[0].minTarGhestBedehkar
                          })
                          .finally(() => {
                            const formData = new FormData()
                            formData.append('wwwtblTaahodatId', this.resTaahodatId[0].id)
                            this.DataAxios_CheckUpMande.ArryfildValue = formData
                            this.$PostFormData(this.DataAxios_CheckUpMande).then((data) => {
                              if (data.length != 0) {
                                // console.log('/*/*/*/')
                                // console.log('/*/*/*/')
                              }
                            })
                            this.wwwJarime = this.resTaahodatId[0].wwwJarime != null ? this.resTaahodatId[0].wwwJarime : 0
                            this.Mablagh = this.resTaahodatId[0].mablaghSharj > 0 ? this.resTaahodatId[0].sumGhabelPar + '' : ''
                          })
                      })
                    this.loadingRender = false
                    resolve(true)
                  }
                })
            }
          })
      })
    },
    GetFastpaymentData() {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$route.query.wwwtblAzaId)
      this.DataAxiosFastPaymnet.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosFastPaymnet).then((data) => {
        if (data.data.length > 0) {
          for (var i = 0; i < data.data.length; i++) {
            var element = data.data[i]
            data.data[i].Active = true
            this.SumJarmieFastPay += element.wwwjarime == null ? 0 : element.wwwjarime
          }
          this.FastpaymentData = data.data
          this.loadingRender = false
        } else {
          this.loadingRender = false
        }
      })
    },
    FastPay() {
      this.loadingRender = true
      const WwwtblVarizGorohiRiz = []
      for (let index = 0; index < this.TotalFastPay.listFastpay.length; index++) {
        WwwtblVarizGorohiRiz.push({
          WwwtblTaahodatId: this.TotalFastPay.listFastpay[index].id,
          Mablagh: this.TotalFastPay.listFastpay[index].mablghPardakht,
          SharhRiz: 'همراه بانک پرداخت قسط تسهیلات ' + this.TotalFastPay.listFastpay[index].vCode,
          WwwtblAzaId: Number(this.$route.query.wwwtblAzaId),
          BnpCashDBtblTaahodatId: this.TotalFastPay.listFastpay[index].bnpCashDBtblTaahodatId,
          BnpCashDBtblAzaId: this.bnpCashDBtblAzaId,
          MablaghJarime: Number(this.TotalFastPay.listFastpay[index].wwwjarime) == null ? 0 : Number(this.TotalFastPay.listFastpay[index].wwwjarime),
          TarixGhest: this.TotalFastPay.listFastpay[index].minTarGhestBedehkar,
        })
      }
      this.SumMablagh = this.TotalFastPay.SumMabFastPay
      this.DataAxios_Variz.ArryfildValue.Mablagh = this.SumMablagh
      this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.Sharh = ' همراه بانک پرداخت اقساط گروهی'
      this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.costCode)
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = Number(5538)
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = Number(this.$route.query.wwwtblAzaId)
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz

      this.$PostData(this.DataAxios_Variz).then((result) => {
        this.$Payment(
          JSON.stringify(this.Dargah),
          JSON.stringify(this.SumMablagh),
          this.nameFamily,
          this.Email,
          this.mobile,
          WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
          this.shenaseVariz == '' ? '' : this.shenaseVariz,
          this.vCode,
          'همراه بانک پرداخت گروهی توسط پرداخت سریع',
          JSON.stringify(Number(this.$route.query.wwwtblAzaId)),
          this.costCode,
          JSON.stringify(this.wwwtblShobeId),
          result.idRepoMaster,
          this.codeMeli,
          this.nameFamily,
          this.mobile,
          this.resTaahodatId[0].codeMeli
        )
      })
      this.loadingRender = false
    },
    gettblCustomer() {
      this.$PostData({
        ArryfildValue: {},
        Action: 'GetTblCustomer',
        method: 'GET',
        Token: '',
      }).then((data) => {
        this.tblcustomer = data
        //console.log('/*/*/*//*/',this.tblcustomer.custCode);
        
      })
    },
  },
}
</script>
<style scoped>
.hampa-pay-page {
  min-height: 100vh;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 12px 16px 28px;
  box-sizing: border-box;
  background: #f5f7fb !important;
}

.hampa-pay-shell {
  width: 100%;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
}

.hampa-pay-layout,
.hampa-pay-main {
  display: grid;
  gap: 8px;
}

.hampa-pay-input {
  min-height: 40px;
  padding: 0.45rem 0.7rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
}

.hampa-pay-amount {
  font-size: 18px !important;
  font-weight: 800;
}

.hampa-pay-amount-meta {
  text-align: center;
}

.hampa-pay-amount-formatted {
  color: #1d7a3a;
  font-size: 14px;
  font-weight: 700;
}

.hampa-pay-result {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  padding: 8px 10px;
  color: #29345f;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  border: 1px solid #e8eef2;
  border-radius: 10px;
  background: #fff;
}

.hampa-pay-result__due {
  color: #b44f46;
}

.hampa-pay-notes {
  min-height: 64px;
  resize: vertical;
}

.hampa-pay-checkout {
  padding: 10px;
  border: 1px solid #e8eef2;
  border-radius: 14px;
  background: #fff;
}

.hampa-pay-hint {
  margin: 0;
  color: #6b7b8e;
  font-size: 12px;
  line-height: 1.7;
  text-align: right;
}

.hampa-pay-submit {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.25rem 0.45rem;
  width: 100%;
  min-height: 42px;
  padding: 0.55rem 0.75rem;
  border-radius: 12px;
  font-weight: 700;
  line-height: 1.4;
  white-space: normal;
}

.hampa-pay-submit__amount {
  min-width: 0;
  overflow-wrap: anywhere;
}

.hampa-fast-summary {
  display: grid;
  gap: 4px;
  padding: 10px 12px;
  color: #29345f;
  border: 1px solid #e8eef2;
  border-radius: 14px;
  background: #fff;
  text-align: center;
}

.hampa-fast-summary__title {
  font-size: 13px;
  font-weight: 800;
}

.hampa-fast-summary__meta {
  display: flex;
  justify-content: center;
  gap: 12px;
  font-size: 12px;
  font-weight: 700;
}

.hampa-fast-summary__amount {
  color: #068997;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.hampa-fast-summary__words {
  color: #6b7b8e;
  font-size: 12px;
  line-height: 1.7;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.hampa-fast-list {
  display: grid;
  gap: 8px;
  max-height: 42vh;
  overflow-y: auto;
}

.hampa-fast-item {
  display: grid;
  gap: 4px;
  padding: 8px 10px;
  border: 1px solid #e8eef2;
  border-right: 3px solid #05b8c8;
  border-radius: 12px;
  background: #fff;
}

.hampa-fast-item__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  color: #6b7b8e;
  font-size: 11px;
}

.hampa-fast-item__row span {
  flex: 0 0 auto;
}

.hampa-fast-item__row strong {
  min-width: 0;
  color: #29345f;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.hampa-fast-item__switch {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 575px) {
  .hampa-pay-notes {
    min-height: 52px;
  }

  .hampa-fast-list {
    max-height: 36vh;
  }

  .hampa-fast-summary__amount {
    font-size: 18px;
  }

  .hampa-fast-summary__words {
    font-size: 11px;
  }
}
</style>
<style>
html.hampa-pay-html,
body.hampa-pay-html,
body.hampa-pay-html #app,
html.hampa-pay-html body,
#HampaPay.hampa-pay-page,
#HampaPay {
  background: #f5f7fb !important;
  background-color: #f5f7fb !important;
  background-image: none !important;
}

#HampaPay .hampa-pay-card.netpa-card,
#HampaPay .hampa-pay-card {
  height: auto !important;
  background: #fff !important;
}

#HampaPay .netpa-card__header,
#HampaPay .netpa-card__body {
  background: #fff !important;
}

@media (max-width: 767px) {
  #HampaPay .netpa-card__header {
    min-height: 48px;
    padding: 10px 12px !important;
  }

  #HampaPay .netpa-card__body {
    padding: 10px !important;
  }

  #HampaPay .netpa-page-panel {
    margin-bottom: 8px;
  }
}
</style>
